import React, { useCallback, useState } from 'react'
import { CollateralBasketDetail } from 'api'
import { Locale, Translation } from 'locale'
import { Tabs } from 'view/components/tabs'
import { Groupbox, ModalFooter, ModalWindow } from 'view/components/panels'
import styled from '@emotion/styled'
import { DialogField, DialogRow } from 'view/components/inputs'
import { TextButton, TextButtonType } from 'view/components/buttons'
import { ReadOnlyCollateralOverviewPanel } from './ReadOnlyCollateralBasketOverviewPanel'
import { ReadOnlyCollateralBasketProductsPanel } from './ReadOnlyCollateralBasketProductsPanel'

interface ReadOnlyCollateralBasketDetailsDialogProps {
  collateralBasketDetail: CollateralBasketDetail
  onClose?: () => unknown
}

const Content = styled(Groupbox)`
  padding: 20px 0px 20px 20px;
  height: 480px;
  width: 550px;
`

export const ReadOnlyCollateralBasketDetailsDialog: React.FC<ReadOnlyCollateralBasketDetailsDialogProps> = props => {
  const { onClose, collateralBasketDetail } = props
  const [selectedTab, setSelectedTab] = useState(Translation.TC_OVERVIEW)
  const tabs = collateralBasketDetail.collateralBasket.dbvClass
    ? [Translation.TC_OVERVIEW]
    : [Translation.TC_OVERVIEW, Translation.TC_PRODUCTS]

  const onChangeTab = useCallback(
    (tab: Translation) => {
      setSelectedTab(tab)
    },
    [setSelectedTab]
  )

  const getSelectedTabContent = useCallback(
    (tab: Translation) => {
      switch (tab) {
        case Translation.TC_OVERVIEW:
          return <ReadOnlyCollateralOverviewPanel collateralBasketDetail={collateralBasketDetail} />
        case Translation.TC_PRODUCTS:
          return <ReadOnlyCollateralBasketProductsPanel collateralBasketDetail={collateralBasketDetail} />
        default:
          return null
      }
    },
    [collateralBasketDetail]
  )

  return (
    <ModalWindow title={collateralBasketDetail.collateralBasket.name}>
      <Tabs selectedTab={selectedTab} onChangeTab={onChangeTab} tabs={tabs} />
      <Content>{getSelectedTabContent(selectedTab)}</Content>
      <ModalFooter>
        <DialogRow>
          <DialogField>
            <TextButton type={TextButtonType.Primary} onClick={onClose}>
              {Locale.translate(Translation.TC_BUTTON_OK)}
            </TextButton>
          </DialogField>
        </DialogRow>
      </ModalFooter>
    </ModalWindow>
  )
}
